import styled from 'styled-components';

export const LoaderContainer = styled.div`
  display: flex;
  height: ${({ isWebview }) => (isWebview ? '100vh' : 'calc(100vh - 49px)')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.color.ui.grey[10]};

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    height: ${({ isWebview }) => (isWebview ? '100vh' : 'calc(100vh - 80px)')};
  }
  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    height: ${({ isWebview }) => (isWebview ? '100vh' : 'calc(100vh - 84px)')};
  }
`;

export const VisuallyHiddenStatus = styled.output`
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

export const SpinnerContainer = styled.div.attrs(() => ({
  'aria-hidden': 'true',
}))``;
